import React, { memo, forwardRef } from "react";
const SvgCapitalD = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M11.08 23.08c-1 0-1.5-.5-1.5-1.5V10.42c0-1 .5-1.5 1.5-1.5h3.52c.92 0 1.847.12 2.78.36.933.24 1.773.64 2.52 1.2.747.547 1.353 1.273 1.82 2.18.467.893.7 2.007.7 3.34 0 1.24-.233 2.307-.7 3.2a6.552 6.552 0 01-1.82 2.2 7.76 7.76 0 01-2.52 1.28c-.933.267-1.86.4-2.78.4h-3.52zm1.02-2.2h2.1c.653 0 1.307-.073 1.96-.22.653-.16 1.24-.42 1.76-.78a4.2 4.2 0 001.3-1.5c.333-.627.5-1.42.5-2.38 0-1.013-.167-1.84-.5-2.48-.333-.64-.767-1.14-1.3-1.5a4.71 4.71 0 00-1.76-.74 9.782 9.782 0 00-1.96-.2h-2.1v9.8z"
      />
    </svg>
  );
});
SvgCapitalD.displayName = "SvgCapitalD";
const MemoForwardRef = memo(SvgCapitalD);
export default MemoForwardRef;
